
import * as React from "react";
import { IUserRestaurantListItem } from "../../interfaces/IRestaurant";
import Maps, { ICenterPosition, IMarker } from "../../../avernus/googlemaps/source/Maps";
import Config from "../../Config";
import { Api } from "../../lib/Api";
import { Lng } from "../../../languages/Languages";
import ReactDOMServer from 'react-dom/server';
import ProfessionalRow from "./ProfessionalRow";

interface IRestaurantMapProps {
    items                     : Array<IUserRestaurantListItem>
    toggleLikeClickHandler    ?:ItoggleLikeClickHandler
    openRestaurantClickHandler?:IopenRestaurantClickHandler
    showLikeBtn               : boolean
    showStartNavigationBtn    : boolean
    centerPosition            :ICenterPosition
}

interface ItoggleLikeClickHandler{
    (evt:any, restaurantId:number, index:number):void
}
interface IopenRestaurantClickHandler{
    (evt:any, id:number):void
}

interface IRestaurantMapState {
    mapHeight: number
}



interface IRestaurantMarker extends IMarker{
    id               : number
    img              : string
    index            : number
    liked            : boolean
    offerNum         : number
    openingTodayStart: string
    openingTodayEnd  : string
    rateing          : number
    addressCountry   : string
    addressState     : string
    addressCity      : string
    addressStreet    : string
    addressZip       : string
    photos           : any
    distance         : any
    name             : any
    offer            : any
}

const Content = marker => {
    return <ProfessionalRow item={marker} />;

}

export default class RestaurantMap extends React.Component<IRestaurantMapProps, IRestaurantMapState>{

    private apiKey: string;


    constructor(props:IRestaurantMapProps){
        super(props);
        this.apiKey             = Config.getAPIKey();
        this.state = {
            mapHeight       : 515
        };
    }

    private getMapHeight() {
        setTimeout(() => {
            if ( this.state.mapHeight === 515 && document.querySelector('.offer_section.googlemap') !== null ) {
                    this.setState({
                        mapHeight: (document.querySelector('.offer_section.googlemap') as HTMLDivElement).offsetHeight + 20
                    });
            }
        }, 200);
    }



    render() {
        let items = this.props.items;
        let markers:Array<IRestaurantMarker> = []
        for (var key in items) {
            var item = items[key];
            markers.push({
                id               : item.id,
                title            : item.name,
                lat              : item.latitude,
                lng              : item.longitude,
                liked            : item.liked,
                img              : item.img,
                offerNum         : item.offerNum,
                openingTodayStart: item.openingTodayStart,
                openingTodayEnd  : item.openingTodayEnd,
                rateing          : item.rateing,
                addressCountry   : item.addressCountry,
                addressState     : item.addressState,
                addressCity      : item.addressCity,
                addressStreet    : item.addressStreet,
                addressZip       : item.addressZip,
                index            : parseInt(key),
                iconName         : 'Info',
                photos           : item.photos,
                distance         : item.distance,
                name             : item.name,
                offer            : item.offer

            });
        }
        this.getMapHeight();
        return (
            <>
                <Maps
                    key={'map_list' }
                    zoom={ 12 }
                    api={this.apiKey}
                    mapId="home_map"
                    width="100%"
                    height={ this.state.mapHeight+ "px"}
                    mapTypeControl = {false}
                    centerPosition = {this.props.centerPosition}
                    mapStyle="default"
                    icons = {[
                        {
                            name: 'Info',
                            url: 'img/mapicon.png'
                        }
                    ]}
                    markers = { markers }

                    markerClickHandler={ (marker:IRestaurantMarker, infowindow:any, markerIcon:any) => {
                        let popover = infowindow.setContent(ReactDOMServer.renderToString(Content(marker)));
                        infowindow.open((window as any).map, markerIcon);
                        setTimeout(() => {
                            if ( document.getElementById('open_logo_btn_'+marker.id) !== null ) {
                                document.getElementById('open_logo_btn_'+marker.id).addEventListener('click', (e) => {
                                    e.preventDefault();
                                    this.props.openRestaurantClickHandler(e, marker.id);
                                });
                            }
                            if ( document.getElementById('open_btn_'+marker.id) !== null ) {
                                document.getElementById('open_btn_'+marker.id).addEventListener('click', (e) => {
                                    e.preventDefault();
                                    this.props.openRestaurantClickHandler(e, marker.id);
                                });
                            }
                            if ( document.getElementById('navigation_btn_'+marker.id) !== null ) {
                                document.getElementById('navigation_btn_'+marker.id).addEventListener('click', (e) => {
                                    e.preventDefault();
                                    Api.openInMap(marker.lat.toString(),marker.lng.toString(), marker.addressStreet);
                                });
                            }
                            if ( document.getElementById('like_btn_'+marker.id) !== null ) {
                                document.getElementById('like_btn_'+marker.id).addEventListener('click', (e) => {
                                    e.preventDefault();
                                    let $this = e.target as HTMLImageElement;
                                    if ( $this.src.indexOf('acourite_icon.svg') > -1 ) {
                                        $this.src = $this.src.replace('facourite_icon.svg','favourite_add_icon_green.svg');
                                    }else{
                                        $this.src = $this.src.replace('favourite_add_icon_green.svg','facourite_icon.svg');
                                    }
                                    this.props.toggleLikeClickHandler(e, marker.id, marker.index);
                                });
                            }
                        }, 400);
                    } }
                />
			</>
        );
    }
}
